import React from 'react';
import PropTypes from 'prop-types'

import Video from './Video'

export default class VideoLoop extends React.PureComponent {

	static propTypes = {
		active: PropTypes.bool,
		muted: PropTypes.bool,
		style: PropTypes.object,
		src: PropTypes.string, // should be required
		poster: PropTypes.string, // should be required
		width: PropTypes.number.isRequired,
		height: PropTypes.number.isRequired
	}

	constructor(props) {
		super(props)
		this.state = {}
	}

	componentDidMount() {
		if (this.props.active) {
			this.setState({ init: true }, () => {
				this.play()
			})
		}
	}

	componentWillReceiveProps(props) {
		if (props.active !== this.props.active || (!this.state.init && props.active)) {
			if (props.active) {
				this.play()
			} else {
				this.pause()
			}
			this.setState({ init: true })
		}
	}

	preload() {
		this.ref.load()
	}

	play() {
		this.ref.play()
	}

	pause() {
		this.ref.pause()
	}

	render() {
		let videoProps = { ...this.props }
		delete videoProps.active
		return (
			<Video ref={ ref => this.ref = ref } { ...videoProps } preload="always" loop={ true } playsInline={true} />
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/video/VideoLoop.jsx